/**
 * Resolve the authenticated user's ID from the user object.
 *
 * Strongly prefers the Cognito `sub` claim — this is the stable, unique,
 * server-verifiable identifier. Falls back to userId/username only for
 * legacy compatibility, with a warning logged so we can track and
 * eliminate those paths.
 *
 * @param {Object|null} user - The authenticated user object
 * @param {Object|null} [userAttributes] - Optional separate attributes object
 * @returns {string|null} The user ID, or null if not authenticated
 */
export function getUserId(user, userAttributes) {
  // Primary: Cognito sub claim (stable, unique, matches JWT)
  if (user?.sub) return user.sub;
  if (userAttributes?.sub) return userAttributes.sub;

  // Fallback: legacy fields — log a warning so we can track these
  const fallback = user?.userId || user?.username || null;
  if (fallback) {
    console.warn('[getUserId] Falling back to non-sub identifier:', fallback, '— user object missing sub claim');
  }
  return fallback;
}
